export interface UrlParamsBuilder {
  build(urlParams: URLSearchParams): URLSearchParams;
}

// Purpose of this class is to chain multiple builders together and build the url params string
// It handles the logic behind the question mark

export type UrlParamsBuilderInput = UrlParamsBuilder[] | UrlParamsBuilder | undefined;

export class ParamsBuilder {
  private readonly builders: UrlParamsBuilderInput;

  constructor(builders: UrlParamsBuilderInput | undefined) {
    this.builders = builders;
  }

  build(): string {
    if (!this.builders) {
      return "";
    }

    if (typeof this.builders === "string") {
      
    }

    let urlParams = new URLSearchParams();

    if (Array.isArray(this.builders)) {
      for (const builder of this.builders) {
        urlParams = builder.build(urlParams);
      }
    } else {
      urlParams = this.builders.build(urlParams);
    }
    const queryString = urlParams.toString();
    return queryString ? `?${queryString}` : "";
  }
}


